Object.defineProperty (module.exports, "__esModule", { value: true }),
module.exports.DateTimeStyle = module.exports.default = {
	CUSTOM: "custom",
	LONG: "long",
	MEDIUM: "medium",
	NONE: "none",
	SHORT: "short",
};